import React from 'react'
import ReactDatePicker from 'react-datepicker'
import styled from 'styled-components'
import CalendarIcon from '../../assets/icons/calendar-icon.svg'
import LeftArrowIcon from '../../assets/icons/left-arrow-icon.svg'
import RightArrowIcon from '../../assets/icons/right-arrow-icon.svg'

const ICON_POSITIONS = {
  left: {
    top: '19px',
    left: '16px',
    padding: '0 16px 0 42px'
  },
  right: {
    top: '19px',
    right: '16px',
    padding: '0 42px 0 16px'
  }
}

export const DatePickerContainer = styled.div`
  position: relative;
  flex: 1;
  .react-datepicker-wrapper{
    .form-control {
      height: 48px;
      border: 1px solid #777777;
      border-radius: 8px;
      &:disabled {
        &:hover {
          border-color:#777777 !important;
        }
      }
      ${({ showIcon, iconPosition }) => `padding: ${showIcon && ICON_POSITIONS[iconPosition].padding}`}
    }
  }
  .react-datepicker {
    width: 346px;
    border: none;
    border-radius: 12px;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12), 0px 4px 8px rgba(0, 0, 0, 0.08);
    z-index: 1;
    &-popper {
      z-index: 2;
    }
    &__triangle {
      display: none;
    }
    &__month-container {
      width: 100%;
      padding: 6px;
    }
    &__month {
      margin: 0;
    }
    &__header {
      background-color: #fff;
      padding: 0;
      border: none;
    }
    &__current-month {
      font-family: 'Nunito';
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 120%;
      color: #555555;
      padding: 16px 0 23px 0;
      text-transform: capitalize;
      letter-spacing: 0.96px;
    }
    &__week {
      display: flex;
      justify-content: space-around;
      gap: 8px;
    }
    &__navigation {
      width: 20px;
      height: 20px;
      border: none;
      background-repeat: no-repeat;
      background-size: 10px 18px;
      background-position: center;
      top: 16px;
      &--previous {
        background-image: url(${LeftArrowIcon});
        left: 26px;
      }
      &--next {
        background-image: url(${RightArrowIcon});
        right: 24px;
      }
      &:focus {
        outline: none;
      }
      span {
        display: none;
      }
    }
    &__day-names {
      display: flex;
      justify-content: space-between;
      margin-bottom: 4px;
    }
    &__day-name {
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 145%;
      text-align: center;
      color: #555555;
      text-transform: uppercase;
      flex: 1;
      max-width: 38px;
    }
    &__day {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: 'Nunito';
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 120%;
      text-align: center;
      letter-spacing: 0.96px;
      color: #555555;
      margin: 4px 0;
      max-width: 38px;
      min-height: 38px;
      border-radius: 100%;
      &--keyboard-selected {
        background: #fff;
        color: #555555;
      }
      &--selecting-range-start,
      &--selecting-range-end {
        background: #01878E;
        color: #fff;
      }
      &--in-range,
      &--in-selecting-range {
        background: #B3EDF0;
        color: #222;
      }
      &--selected,
      &--range-start,
      &--range-end {
        background-color: #01878E;
        color: #fff;
      }
      &.unavailable {
        background-color: #FFDAB3;
        color: #222;
        font-weight: 700;

        &.react-datepicker__day--today {
          border: 2px solid #FFDAB3;
          background-color: #fff;
        }
      }
      &.activeCampaign {
        font-weight: 700;
        background-color: #DAF2D4;
        color: #222222;

        &.react-datepicker__day--today {
          border: 2px solid #DAF2D4;
          background-color: #fff;
        }
      }
      &--today {
        border: 2px solid #B3EDF0;
        background-color: #fff;
        color: #222;
        font-weight: 700;
        font-size: 16px;
      }
      &.react-datepicker__day--selected {
        border: none !important;
        color: #fff !important;
        background-color: #01878E;
        &.unavailable {
          background-color: #E67500;
        }
        &.activeCampaign {
          background-color: #25B000;
        }
      }
    }
    .react-datepicker__day--disabled,.react-datepicker__day--outside-month {
      color: #DADADA;
      background: none;
    }
    &__time-container {
      width: 100%;
      margin-bottom: 16px;
      @media (min-width: 768px) {
        overflow-x: auto;
        overflow-y: hidden;
        display: flex;
        ::-webkit-scrollbar {
          height: 8px;
        }
        ::-webkit-scrollbar-track {
          background: #f1f1f1;
        }

        ::-webkit-scrollbar-thumb {
          background: #888;
        }

        ::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
      }
    }
    &__header--time {
      display: none;
    }
    .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
      width: 100%;
    }

    &__time-list {
      height: initial !important;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 8px 16px;
      gap: 8px;
      ::-webkit-scrollbar {
        display: none;
      }
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
    &__time-list-item {
      height: 30px;
      white-space: nowrap;
      font-weight: 400;
      font-size: 16px;
      line-height: 145%;
      &.unavailable {
        color: #FF8200;
        &.react-datepicker__time-list-item--selected {
          background-color: #FF8200 !important;
        }
      }
      &--selected {
        border-radius: 30px;
        background-color: #01878E !important;
        color: #fff;
        &.activeCampaign {
          background-color: #25B000 !important;
        }
      }
    }
    .start {
      background: #01878E;
      color: #fff;
    }
    .end {
      background: #01878E;
      color: #fff;
    }

    .react-datepicker__input-time-container .react-datepicker-time__input-container {
    display: inline-block;
    font-family: 'Open Sans';
    font-weight: 400;
    font-size: 16px;
    line-height: 145%;
    }
  }
`

export const ErrorMessage = styled.p`
  color: #ff0000;
  font-size: 13px;
  font-family: 'Open Sans';
  font-weight: 400;
  margin: 0px;
`

export const Label = styled.label`
  position: absolute;
  top: -12px;
  left: 14px;
  margin: 0px;
  background: rgb(255,255,255);
  background: linear-gradient(0deg, rgba(255,255,255,0) 50%, rgba(255,255,255,1) 50%);
  color: #222;
  font-size: 12px;
  font-family: 'Open Sans';
  font-weight: 400;
  padding: 4px;
  z-index: 1;
 `

export const Icon = styled.img`
  position: absolute;
  z-index: 1;
  ${({ iconPosition }) => ICON_POSITIONS[iconPosition]}
  margin: 0px;
  padding: 0px;
`

const DatePicker = ({ label, showIcon, iconPosition = 'left', errorMessage, ...rest }) => {
  return (
    <DatePickerContainer iconPosition={iconPosition} showIcon={showIcon}>
      <Label>{label}</Label>
      {showIcon && <Icon iconPosition={iconPosition} src={CalendarIcon} alt='ícone de calendário'/>}
      <ReactDatePicker
        {...rest}
      />
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </DatePickerContainer>
  )
}

export default DatePicker
